import { render, staticRenderFns } from "./ErrorSummary.vue?vue&type=template&id=35b13b6d"
import script from "./ErrorSummary.vue?vue&type=script&lang=js"
export * from "./ErrorSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/notification/Notification.vue').default})
